module.exports = __webpack_public_path__ + "static/Doctor_Dis_Guide-7d1680f71eabd106fcb759d13ae4cd9f.png";